import dayjs from "@shared/dayjs";

export const getTrackingNumberIds = (selectedTrackingNumbers, trackingNumbers) => {
  return selectedTrackingNumbers.length === trackingNumbers.length
    ? []
    : selectedTrackingNumbers.filter((tn) => tn !== null).map((tn) => tn.value);
};

export const durationDisplay = (durationSeconds) =>
  new Date(durationSeconds * 1000).toISOString().substring(11, 19);

export const formatCallDuration = (durationInSeconds) => {
  if (!durationInSeconds) {
    return;
  }

  if (durationInSeconds === Infinity) {
    return "--:--:--";
  }

  const duration = dayjs.duration(Math.floor(durationInSeconds), "seconds");
  const hours = Math.floor(duration.asHours());
  const minutes = duration.minutes();
  const seconds = duration.seconds();

  return [hours || 0, minutes || 0, seconds || 0].map(padWithZeroes).join(":");
};

const padWithZeroes = (num) => String(num).padStart(2, "0");
